import { useState, useEffect } from 'react';
import { useToken } from '../App';
import { API_ENDPOINTS } from '../config/api';
import { updatePageTitle } from '../utils/title';

export const useHotelTitle = (pageName?: string) => {
  const { hotelId } = useToken()!;
  const [hotelName, setHotelName] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (hotelId) {
      setLoading(true);
      fetch(API_ENDPOINTS.HOTELS(hotelId))
        .then(res => res.json())
        .then(data => {
          const name = data.hotel_name || '';
          setHotelName(name);
          updatePageTitle(name, pageName);
          setLoading(false);
        })
        .catch(() => {
          setHotelName('');
          updatePageTitle('', pageName);
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, [hotelId, pageName]);

  return { hotelName, loading };
}; 